window.Frame = window.Frame || {};
window.Frame.Redirects = window.Frame.Redirects || {};
window.Frame.Redirects.Countries = [
	{
		"name": "Afghanistan",
		"country_code": "af",
		"currency_one": "AFN",
		"currency_two": "",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Albania",
		"country_code": "al",
		"currency_one": "ALL",
		"currency_two": "USD",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Algeria",
		"country_code": "dz",
		"currency_one": "DZD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Andorra",
		"country_code": "ad",
		"currency_one": "EUR",
		"currency_two": "",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Angola",
		"country_code": "ao",
		"currency_one": "AOA",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Anguilla",
		"country_code": "ai",
		"currency_one": "XCD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Antigua & Barbuda",
		"country_code": "ag",
		"currency_one": "XCD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Argentina",
		"country_code": "ar",
		"currency_one": "ARS",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Armenia",
		"country_code": "am",
		"currency_one": "AMD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Aruba",
		"country_code": "aw",
		"currency_one": "AWG",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Australia",
		"country_code": "au",
		"currency_one": "AUD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Austria",
		"country_code": "at",
		"currency_one": "EUR",
		"currency_two": "",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Azerbaijan",
		"country_code": "az",
		"currency_one": "AZM",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Bahamas",
		"country_code": "bs",
		"currency_one": "BSD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Bahrain",
		"country_code": "bh",
		"currency_one": "BHD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Bangladesh",
		"country_code": "bd",
		"currency_one": "BDT",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Barbados",
		"country_code": "bb",
		"currency_one": "BBD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Belarus",
		"country_code": "by",
		"currency_one": "BYR",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Belgium",
		"country_code": "be",
		"currency_one": "EUR",
		"currency_two": "",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Belize",
		"country_code": "bz",
		"currency_one": "BZD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Benin",
		"country_code": "bj",
		"currency_one": "XOF",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Bermuda",
		"country_code": "bm",
		"currency_one": "BMD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Bhutan",
		"country_code": "bt",
		"currency_one": "INR",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Bolivia",
		"country_code": "bo",
		"currency_one": "BOB",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Bosnia Herzegovina",
		"country_code": "ba",
		"currency_one": "BAM",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Botswana",
		"country_code": "bw",
		"currency_one": "BWP",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Brazil",
		"country_code": "br",
		"currency_one": "BRL",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Brunei Darussalam",
		"country_code": "bn",
		"currency_one": "BND",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Bulgaria",
		"country_code": "bg",
		"currency_one": "BGN",
		"currency_two": "EUR",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Burkina Faso",
		"country_code": "bf",
		"currency_one": "XOF",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Burundi",
		"country_code": "bi",
		"currency_one": "BIF",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Cambodia",
		"country_code": "kh",
		"currency_one": "KHR",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Cameroon",
		"country_code": "cm",
		"currency_one": "XAF",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Canada",
		"country_code": "ca",
		"currency_one": "CAD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Cape Verde",
		"country_code": "cv",
		"currency_one": "CVD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Central African Republic",
		"country_code": "cf",
		"currency_one": "XAF",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Chad",
		"country_code": "td",
		"currency_one": "XAF",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Chile",
		"country_code": "cl",
		"currency_one": "CLP",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "China",
		"country_code": "cn",
		"currency_one": "CNY",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Colombia",
		"country_code": "co",
		"currency_one": "COP",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Comoros Islands",
		"country_code": "km",
		"currency_one": "KMF",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Congo",
		"country_code": "cg",
		"currency_one": "XAF",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Costa Rica",
		"country_code": "cr",
		"currency_one": "CRC",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Croatia",
		"country_code": "hr",
		"currency_one": "HRK",
		"currency_two": "EUR",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Cuba",
		"country_code": "cu",
		"currency_one": "CUP",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Cyprus",
		"country_code": "cy",
		"currency_one": "EUR",
		"currency_two": "",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Czech Republic",
		"country_code": "cz",
		"currency_one": "CZK",
		"currency_two": "EUR",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Democratic Republic of the Congo",
		"country_code": "cd",
		"currency_one": "GBP",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Denmark",
		"country_code": "dk",
		"currency_one": "DKK",
		"currency_two": "EUR",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Djibouti",
		"country_code": "dj",
		"currency_one": "DJF",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Ecuador",
		"country_code": "ec",
		"currency_one": "USD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Egypt",
		"country_code": "eg",
		"currency_one": "EGP",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "El Salvador",
		"country_code": "sv",
		"currency_one": "SVC",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Eritrea",
		"country_code": "er",
		"currency_one": "ERN",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Estonia",
		"country_code": "ee",
		"currency_one": "EUR",
		"currency_two": "",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Falkland Islands",
		"country_code": "fk",
		"currency_one": "FKP",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Faroe Islands",
		"country_code": "fo",
		"currency_one": "DKK",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Fiji",
		"country_code": "fj",
		"currency_one": "FJD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Finland",
		"country_code": "fi",
		"currency_one": "EUR",
		"currency_two": "",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "France",
		"country_code": "fr",
		"currency_one": "EUR",
		"currency_two": "",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "French Polynesia",
		"country_code": "pf",
		"currency_one": "XPF",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
  {
		"name": "French Southern Territories",
		"country_code": "tf",
		"currency_one": "EUR",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Gabon",
		"country_code": "ga",
		"currency_one": "XAF",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Gambia",
		"country_code": "gm",
		"currency_one": "GMD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Georgia",
		"country_code": "ge",
		"currency_one": "GEL",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Germany",
		"country_code": "de",
		"currency_one": "EUR",
		"currency_two": "",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Ghana",
		"country_code": "gh",
		"currency_one": "GHC",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Gibraltar",
		"country_code": "gi",
		"currency_one": "GIP",
		"currency_two": "EUR",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Greece",
		"country_code": "gr",
		"currency_one": "EUR",
		"currency_two": "",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Greenland",
		"country_code": "gl",
		"currency_one": "DKK",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Grenada",
		"country_code": "gd",
		"currency_one": "XCD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
  {
		"name": "Guernsey",
		"country_code": "gg",
		"currency_one": "GGP",
		"currency_two": "GBP",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Guadeloupe",
		"country_code": "gp",
		"currency_one": "EUR",
		"currency_two": "",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Guatemala",
		"country_code": "gt",
		"currency_one": "GTQ",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Guinea",
		"country_code": "gn",
		"currency_one": "GNF",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Guinea Bissau",
		"country_code": "gw",
		"currency_one": "XOF",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Guyana",
		"country_code": "gy",
		"currency_one": "GYD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Haiti",
		"country_code": "ht",
		"currency_one": "HTG",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Honduras",
		"country_code": "hn",
		"currency_one": "USD",
		"currency_two": "",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Hong Kong",
		"country_code": "hk",
		"currency_one": "HKD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Hungary",
		"country_code": "hu",
		"currency_one": "HUF",
		"currency_two": "EUR",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Iceland",
		"country_code": "is",
		"currency_one": "ISK",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "India",
		"country_code": "in",
		"currency_one": "INR",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
    {
		"name": "Indonesia",
		"country_code": "id",
		"currency_one": "IDR",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Iran",
		"country_code": "ir",
		"currency_one": "IRR",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Iraq",
		"country_code": "iq",
		"currency_one": "IQD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Ireland",
		"country_code": "ie",
		"currency_one": "EUR",
		"currency_two": "",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Israel",
		"country_code": "il",
		"currency_one": "ILS",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
  {
		"name": "Isle of Man",
		"country_code": "im",
		"currency_one": "IMP",
		"currency_two": "GBP",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Italy",
		"country_code": "it",
		"currency_one": "EUR",
		"currency_two": "",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Ivory Coast",
		"country_code": "ci",
		"currency_one": "XOF",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Jamaica",
		"country_code": "jm",
		"currency_one": "JMP",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Japan",
		"country_code": "jp",
		"currency_one": "JPY",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
  {
		"name": "Jerseys",
		"country_code": "je",
		"currency_one": "JEP",
		"currency_two": "GBP",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Jordan",
		"country_code": "jo",
		"currency_one": "JOD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Kazakhstan",
		"country_code": "kz",
		"currency_one": "KZT",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Kenya",
		"country_code": "ke",
		"currency_one": "KES",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Korea Democratic Peoples Republic of",
		"country_code": "kp",
		"currency_one": "PRK",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Korea Republic of",
		"country_code": "kr",
		"currency_one": "KOR",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Kosovo",
		"country_code": "xk",
		"currency_one": "EUR",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Krygyzstan",
		"country_code": "kg",
		"currency_one": "KGS",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Kuwait",
		"country_code": "kw",
		"currency_one": "KWD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Laos",
		"country_code": "la",
		"currency_one": "LAK",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Latvia",
		"country_code": "lv",
		"currency_one": "EUR",
		"currency_two": "",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Lebanon",
		"country_code": "lb",
		"currency_one": "LBP",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Lesotho",
		"country_code": "ls",
		"currency_one": "LSL",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Liechtenstein",
		"country_code": "li",
		"currency_one": "CHF",
		"currency_two": "USD",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Lithuania",
		"country_code": "lt",
		"currency_one": "EUR",
		"currency_two": "",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Luxembourg",
		"country_code": "lu",
		"currency_one": "EUR",
		"currency_two": "",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Macau",
		"country_code": "mo",
		"currency_one": "MOP",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Macedonia",
		"country_code": "mk",
		"currency_one": "MKD",
		"currency_two": "EUR",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Madagascar",
		"country_code": "mg",
		"currency_one": "MGA",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Madeira",
		"country_code": "pt",
		"currency_one": "EUR",
		"currency_two": "",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Malaysia",
		"country_code": "my",
		"currency_one": "MYR",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Maldives",
		"country_code": "mv",
		"currency_one": "MVR",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Mali",
		"country_code": "ml",
		"currency_one": "XOF",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Malta",
		"country_code": "mt",
		"currency_one": "EUR",
		"currency_two": "",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Marshall Islands",
		"country_code": "mh",
		"currency_one": "USD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Martinique",
		"country_code": "mq",
		"currency_one": "EUR",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Mauritania",
		"country_code": "mr",
		"currency_one": "MRD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Mauritius",
		"country_code": "mu",
		"currency_one": "MUR",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Mexico",
		"country_code": "mx",
		"currency_one": "MXN",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Moldova",
		"country_code": "md",
		"currency_one": "MDL",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Monaco",
		"country_code": "mc",
		"currency_one": "EUR",
		"currency_two": "",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Mongolia",
		"country_code": "mn",
		"currency_one": "MNT",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Montenegro",
		"country_code": "cs",
		"currency_one": "CSP",
		"currency_two": "USD",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Montserrat",
		"country_code": "ms",
		"currency_one": "XCD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Morocco",
		"country_code": "ma",
		"currency_one": "MAS",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Nepal",
		"country_code": "np",
		"currency_one": "NPR",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Netherlands",
		"country_code": "nl",
		"currency_one": "EUR",
		"currency_two": "",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "New Caledonia",
		"country_code": "nc",
		"currency_one": "XPF",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "New Zealand",
		"country_code": "nz",
		"currency_one": "NZD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Niger",
		"country_code": "ne",
		"currency_one": "XOF",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Nigeria",
		"country_code": "ng",
		"currency_one": "NGN",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Norway",
		"country_code": "no",
		"currency_one": "NOK",
		"currency_two": "EUR",
		"flag": "",
		"store_code": "eu"
	},
  {
		"name": "North Macedonia",
		"country_code": "mk",
		"currency_one": "MKD",
		"currency_two": "EUR",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Oman",
		"country_code": "om",
		"currency_one": "OMR",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Pakistan",
		"country_code": "pk",
		"currency_one": "PKR",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Panama",
		"country_code": "pa",
		"currency_one": "PAB",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Paraguay",
		"country_code": "br",
		"currency_one": "PYG",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Peru",
		"country_code": "pe",
		"currency_one": "PEN",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Philippines",
		"country_code": "ph",
		"currency_one": "PHP",
		"currency_two": "",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Poland",
		"country_code": "pl",
		"currency_one": "PLN",
		"currency_two": "EUR",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Portugal",
		"country_code": "pt",
		"currency_one": "EUR",
		"currency_two": "",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Puerto Rico",
		"country_code": "pr",
		"currency_one": "USD",
		"currency_two": "",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Qatar",
		"country_code": "qa",
		"currency_one": "QAR",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Reunion",
		"country_code": "re",
		"currency_one": "EUR",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Romania",
		"country_code": "ro",
		"currency_one": "ROL",
		"currency_two": "EUR",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Russia",
		"country_code": "ru",
		"currency_one": "RUB",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Saint Vincent and the Grenadines",
		"country_code": "vc",
		"currency_one": "XCD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Samoa",
		"country_code": "ws",
		"currency_one": "WST",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Samoa (American)",
		"country_code": "ws",
		"currency_one": "WSR",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "San Marino",
		"country_code": "sm",
		"currency_one": "EUR",
		"currency_two": "",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Sao Tome and Principe",
		"country_code": "st",
		"currency_one": "STD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Sardinia",
		"country_code": "it",
		"currency_one": "EUR",
		"currency_two": "",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Saudi Arabia",
		"country_code": "sa",
		"currency_one": "SAR",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Senegal",
		"country_code": "sn",
		"currency_one": "XOF",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Serbia",
		"country_code": "cs",
		"currency_one": "CSP",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Seychelles",
		"country_code": "sc",
		"currency_one": "SCR",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Sicily",
		"country_code": "it",
		"currency_one": "EUR",
		"currency_two": "",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Sierra Leone",
		"country_code": "sl",
		"currency_one": "SLL",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Singapore",
		"country_code": "sg",
		"currency_one": "SGD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Slovak Republic",
		"country_code": "sk",
		"currency_one": "EUR",
		"currency_two": "",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Slovenia",
		"country_code": "si",
		"currency_one": "EUR",
		"currency_two": "",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Solomon Islands",
		"country_code": "sb",
		"currency_one": "SBD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Somalia",
		"country_code": "so",
		"currency_one": "SOS",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "South Africa",
		"country_code": "za",
		"currency_one": "ZAR",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Spain",
		"country_code": "es",
		"currency_one": "EUR",
		"currency_two": "",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Sri Lanka",
		"country_code": "lk",
		"currency_one": "LKR",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "St. Helena",
		"country_code": "sh",
		"currency_one": "SHP",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "St. Kitts and Nevis",
		"country_code": "kn",
		"currency_one": "XCD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "St. Lucia",
		"country_code": "lc",
		"currency_one": "XCD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "St. Pierre and Miquelon",
		"country_code": "pm",
		"currency_one": "EUR",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Sudan",
		"country_code": "sd",
		"currency_one": "SDD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Suriname",
		"country_code": "sr",
		"currency_one": "SRD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Svalbard and Jan Mayen Islands",
		"country_code": "sj",
		"currency_one": "NOK",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Eswatini",
		"country_code": "sz",
		"currency_one": "SZL",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Sweden",
		"country_code": "se",
		"currency_one": "SEK",
		"currency_two": "EUR",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Switzerland",
		"country_code": "ch",
		"currency_one": "CHF",
		"currency_two": "USD",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Syria",
		"country_code": "sy",
		"currency_one": "SYP",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Tahiti",
		"country_code": "pf",
		"currency_one": "XPF",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Taiwan Province of China",
		"country_code": "tw",
		"currency_one": "TWD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Tajikistan",
		"country_code": "tj",
		"currency_one": "TJB",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Tanzania",
		"country_code": "tz",
		"currency_one": "TZS",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Thailand",
		"country_code": "th",
		"currency_one": "THB",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Togo",
		"country_code": "tg",
		"currency_one": "XOF",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Tokelau",
		"country_code": "tk",
		"currency_one": "NZD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Tonga",
		"country_code": "to",
		"currency_one": "TOP",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Trinidad and Tobago",
		"country_code": "tt",
		"currency_one": "TTD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Tunisia",
		"country_code": "tn",
		"currency_one": "TND",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Turkey",
		"country_code": "tr",
		"currency_one": "TRY",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Turkmenistan",
		"country_code": "tm",
		"currency_one": "TMM",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Turks and Caicos Islands",
		"country_code": "tc",
		"currency_one": "USD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Tuvalu",
		"country_code": "tv",
		"currency_one": "TVD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Uganda",
		"country_code": "ug",
		"currency_one": "UGX",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Ukraine",
		"country_code": "ua",
		"currency_one": "UAH",
		"currency_two": "USD",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "United Arab Emirates",
		"country_code": "ae",
		"currency_one": "AED",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "United Kingdom",
		"country_code": "gb",
		"currency_one": "GBP",
		"currency_two": "",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "United States",
		"country_code": "us",
		"currency_one": "USD",
		"currency_two": "",
		"flag": "",
		"store_code": "us"
	},
  {
		"name": "U.S. Outlying Islands",
		"country_code": "um",
		"currency_one": "USD",
		"currency_two": "",
		"flag": "",
		"store_code": "us"
	},
	{
		"name": "Uruguay",
		"country_code": "uy",
		"currency_one": "UYU",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Uzbekistan",
		"country_code": "uz",
		"currency_one": "UZS",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Vanuatu",
		"country_code": "vu",
		"currency_one": "VUV",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Vatican City State",
		"country_code": "va",
		"currency_one": "EUR",
		"currency_two": "USD",
		"flag": "",
		"store_code": "eu"
	},
	{
		"name": "Venezuela",
		"country_code": "ve",
		"currency_one": "VEB",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Vietnam",
		"country_code": "vn",
		"currency_one": "VND",
		"currency_two": "USD",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Virgin Islands (British)",
		"country_code": "vg",
		"currency_one": "USD",
		"currency_two": "",
		"flag": "",
		"store_code": "am"
	},
	{
		"name": "Virgin Islands (USA)",
		"country_code": "VI",
		"currency_one": "USD",
		"currency_two": "",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Wallis and Futuna Islands",
		"country_code": "wf",
		"currency_one": "XDF",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Yemen",
		"country_code": "ye",
		"currency_one": "YER",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Zambia",
		"country_code": "zm",
		"currency_one": "ZMK",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	},
	{
		"name": "Zimbabwe",
		"country_code": "zw",
		"currency_one": "ZWD",
		"currency_two": "USD",
		"flag": "",
		"store_code": "gb"
	}
]